import { createFileRoute } from '@tanstack/react-router';

import {
  SampleTestsPage,
  validateSampleTestsSearch,
} from '../../features/sample-tests';

export const Route = createFileRoute('/_app/sample-tests')({
  staticData: { crumbs: ['План тестирования образцов'] },
  // Фильтры, сортировка и страница живут в адресной строке - валидируем их здесь.
  validateSearch: validateSampleTestsSearch,
  component: SampleTestsPage,
});
